module.exports = new __parcel__URL__("skunk.a5578a4f.svg").toString();